import HttpClient from "./HttpClient.js";
import Pallet from "./Pallet.js";
import Product from "./Product.js";
import Customer from "./Customer.js";
import Truck from "./Truck.js";
import Address from "./Address.js";
import OrderSupplier from "./OrderSupplier.js";
import Helper from "./Helper.js";
import Operation from "./Operation.js";
export default class Order {
  constructor(order) {
    this.id = order.id;
    this.area = order.area;
    this.checked = order.checked;
    this.count = order.count;
    this.offer_id = order.offer_id;
    this.customer_id = order.customer_id;
    this.production_id = order.production_id;
    this.delivery_date = order.delivery_date;
    this.status = order.status;
    this.user_id = order.user_id;
    this.company_id = order.company_id;
    this.created_at = order.created_at;
    this.updated_at = order.updated_at;
    this.delivery_address = order.delivery_address;
    this.contact_id = order.contact_id;
    this.customer_order_number = order.customer_order_number;
    this.manager_email = order.manager_email;
    this.truck_id = order.truck_id;
    this.pal_status = order.pal_status;
    this.serial_number = order.serial_number;
    this.customer =
      typeof order.customer === "string"
        ? order.customer
        : new Customer(order.customer);
    this.address = (order.address != null) ? new Address(order.address) : null;
    this.products =
      order.products != null ? this.getProducts(order.products) : [];
    this.completion_date = order.completion_date;
    this.additional_products_count = order.additional_products_count;
    this.suppliers = this.getSuppliers(order.suppliers);
    this.week = order.week;
    this.product_type = order.product_type;
    this.wood_type = order.wood_type;
    this.paint_type = order.paint_type;
    this.element_count = order.element_count;
    this.spross_count = order.spross_count;
  }

  static async loadSpecific(orderIds) {
    const client = new HttpClient();
    const response = await client.instance.get("orders/many/id", {
      params: {
        orders: orderIds
      }
    });
    const orders = [];
    response.data.forEach(order => {
      orders.push(new Order(order));
    });
    return orders;
  }

  static async create(order) {
    const client = new HttpClient();
    await client.instance.post("orders", order);
  }

  async update(order) {
    const client = new HttpClient();
    await client.instance.put(`orders/${this.id}`, order);
  }

  static async updateMany(orders) {
    const client = new HttpClient();
    const response = await client.instance.put("orders", {
      orders: orders
    });
    return response.data;
  }

  async remove() {
    const client = new HttpClient();
    await client.instance.delete(`orders/${this.id}`);
  }

  static async removeOrders(orders) {
    const client = new HttpClient();
    const response = await client.instance.delete('orders', {
      params: {
        orders: orders
      }
    });
    return response.data;
  }

  getSuppliers(orderSuppliers) {
    const suppliers = [];
    if (!orderSuppliers) {
      return suppliers;
    }
    orderSuppliers.forEach(supplier => {
      suppliers.push(new OrderSupplier(supplier));
    });
    return suppliers;
  }

  getProducts(productObjects) {
    let products = [];
    productObjects.forEach(product => {
      products.push(new Product(product));
    });
    return products;
  }

  loadedCount(pallets) {
    let loadedCount = 0;
    this.products.forEach(product => {
      if (product.withinPallets(pallets)) {
        loadedCount++;
      }
    });
    return loadedCount;
  }

  allLoaded(pallets) {
    return this.products.length == this.loadedCount(pallets);
  }

  toString(empty) {
    let name = empty ? empty : "";
    if (this.offer_id != null) name = this.offer_id;
    if (this.production_id) name = this.production_id;
    return name;
  }

  /**
   * converts array of orders from api to this order array
   * @param {*} orderObj
   */
  static getOrdersArray(orderObj) {
    let orders = [];
    orderObj.forEach(order => {
      orders.push(new Order(order));
    });
    return orders;
  }

  /**
   * prepares data for viewing in palleting page
   * @param {String} filter
   */
  static async getOrderPalleting(filter) {
    const client = new HttpClient();
    const pallets = [];
    const orders = [];
    const trucks = [];
    const response = await client.instance.get("/orders-pallets", {
      params: {
        filter: filter.filter,
        pal_status_from: filter.pal_status_from,
        pal_status_to: filter.pal_status_to
      }
    });
    response.data.orders.forEach(order => {
      const orderObj = new Order(order);
      const products = [];
      orderObj.products.forEach(product => {
        if (product.part_of == null) {
          products.push(product);
        }
      });
      orderObj.products = products;
      orders.push(orderObj);
    });
    response.data.pallets.forEach(pallet => {
      pallet.products.filter(product => {
        return product.part_of == null;
      });
      pallet.products = pallet.products.sort((a, b) => {
        //sort by y first
        if (a.y > b.y) return 1;
        if (a.y < b.y) return -1;
        //then by z
        if (a.z > b.z) return 1;
        if (a.z < b.z) return -1;
        //then by x
        if (a.x > b.x) return 1;
        if (a.x < b.x) return -1;
      });
      const palletObj = new Pallet(pallet);
      pallets.push(palletObj);
    });
    response.data.trucks.forEach(truck => {
      trucks.push(new Truck(truck, pallets));
    });
    return { pallets, orders, trucks };
  }

  /**
   * sorts orders by pallet priority
   * @param {Truck} truck
   * @param {Array} orders
   */
  static sortByPalletPriority(truck, orders) {
    orders.forEach(order => {
      if (!order.products) {
        order.dispatch_priority = 1;
      }
      let selectedProduct = null;
      order.products.forEach(product => {
        if (selectedProduct == null && product.pallet_id != null) {
          const pallet = truck.pallets.find(e => {
            return e.id == product.pallet_id;
          })
          if (pallet) {
            if (pallet.truck_id == truck.id) {
              selectedProduct = product;
              order.dispatch_priority = pallet.dispatch_priority;
            }
          }
        }
        if (selectedProduct == null) {
          order.dispatch_priority = 1;
        }
      })
    });
    orders.sort((a, b) => {
      return a.dispatch_priority - b.dispatch_priority;
    })
    return orders;
  }

  static getDispatchPriority(orders) {
    let priority = 100;
    orders.forEach(order => {
      priority = Math.min(priority, order.dispatch_priority);
    });
    return priority;
  }

  /**
   * returns true if at least product of order
   * is in truck
   * @param {Truck} truck 
   */
  inTruck(truck) {
    for (let i = 0; i < this.products.length; i++) {
      if (this.products[i].pallet_id != null) {
        const pallet = truck.pallets.find(e => {
          return e.id === this.products[i].pallet_id;
        })
        if (pallet) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * removes all pallets and trucks
   */
  async unpack() {
    const client = new HttpClient();
    const response = await client.instance.delete(`orders/${this.id}/unpack`);
    return response.data;
  }

  static async loadOrders(data) {
    const client = new HttpClient();
    const response = await client.instance.post("orders/many", data);
    return response.data;
  }

  /**
   * gets different orders in pallets
   * @param {*} pallets 
   */
  static getOrdersFromPallets(pallets) {
    let orders = []
    pallets.forEach(pallet => {
      pallet.products.forEach(product => {
        if (!orders.some(e => e.id === product.order.id)) {
          orders.push(product.order);
        }
      })
    });
    return orders;
  }

  /**
   * goes through pallets and collects order names
   * @param {*} pallets 
   */
  static getOrdersString(orders) {
    let ordersString = "";
    orders.forEach((order, i) => {
      ordersString += order.toString();
      if (orders.length - 1 != i && orders.length > 1) {
        ordersString += ", ";
      }
    });
    return ordersString;
  }

  /**
   * goes through pallets and collects customer names
   * @param {*} pallets 
   */
  static getCustomersString(orders) {
    let customersString = "";
    const customerNames = [];
    orders.forEach(order => {
      if (!customerNames.includes(order.customer.toString())) {
        customerNames.push(order.customer.toString());
      }
    });
    customerNames.forEach((customer, i) => {
      customersString += customer;
      if (customerNames.length - 1 != i && customerNames.length > 1) {
        customersString += ", ";
      }
    });
    return customersString;
  }

  static getProductionIds(orders) {
    const productionIds = [];
    orders.forEach(order => {
      if (!productionIds.includes(order.production_id)) {
        productionIds.push(order.production_id);
      }
    });
    let productionIdsString = "";
    productionIds.forEach((productionId, i) => {
      productionIdsString += productionId;
      if (productionIds.length - 1 != i && productionIds.length > 1) {
        productionIdsString += ",";
      }
    });
    return productionIdsString;
  }

  getOperationsArray() {
    const operations = [];
    this.products.forEach(product => {
      product.operations.forEach(operation => {
        operations.push(operation);
      })
    });
    return operations;
  }

  getWorkCenterOperations(workCenterId) {
    let operations = [];
    for (const product of this.products) {
      operations = [...operations, ...product.getWorkCenterOperations(workCenterId)];
    }
    return operations;
  }

  getWorkCentersOperations(workCenters){
    let operations = [];
    for(const workCenter of workCenters){
      operations = [...operations, ...this.getWorkCenterOperations(workCenter.id)];
    }
    return operations;
  }

  static async getOrdersInProduction(filter, type, statusFrom, statusTo, oldOrders) {
    const client = new HttpClient();
    const response = await client.instance.get("orders/many/production", {
      params: {
        filter: filter,
        type: type,
        status_from: statusFrom,
        status_to: statusTo
      }
    });
    const orders = Order.getExpandedOrders(response.data, oldOrders);
    orders.sort((a, b) => {
      //gets dates of expected soonest products
      const dateA = new Date(a.getCompletionDate());
      const dateB = new Date(b.getCompletionDate());
      //get oldest first
      return dateA.getTime() - dateB.getTime();
    })
    return orders;
  }

  static async getOrdersInProduction1(filter, type, statusFrom, statusTo, oldOrders) {
    const client = new HttpClient();
    const response = await client.instance.get("orders/many/production1", {
      params: {
        filter: filter,
        type: type,
        status_from: statusFrom,
        status_to: statusTo
      }
    });
    const orders = Order.getExpandedOrders(response.data, oldOrders);
    orders.sort((a, b) => {
      //gets dates of expected soonest products
      const dateA = new Date(a.delivery_date);
      const dateB = new Date(b.delivery_date);
      //get oldest first
      return dateA.getTime() - dateB.getTime();
    })
    return orders;
  }

  getCompletionDate() {
    let oldest = new Date(this.products[0].completion_date);
    for (let i = 0; i < this.products.length - 1; i++) {
      const dateA = new Date(this.products[i].completion_date);
      const dateB = new Date(this.products[i + 1].completion_date);

      if (dateA.getTime() - dateB.getTime() > 0) {
        oldest = dateB;
      }
    }
    return oldest.toLocaleDateString('lt-LT');
  }

  getDaysUntilDue(dateParm = "completion_date") {
    const today = new Date();
    const completionDate = new Date(this[dateParm]);
    // To calculate the time difference of two dates 
    const differenceInTime = completionDate.getTime() - today.getTime();

    // To calculate the no. of days between two dates
    return Math.floor(differenceInTime / (1000 * 3600 * 24));
  }

  getWorkCenterProductsCount(workCenterId) {
    let count = 0;
    for (const product of this.products) {
      count += product.getWorkCenterOperation(workCenterId) != null ? 1 : 0;
      count += 0;
    }
    return count;
  }

  getRemainingProducts(workCenterId) {
    let count = 0;
    for (const product of this.products) {
      count += product.operationNotCompleted(workCenterId);
    }
    return count;
  }

  static getExpandedOrders(newOrders, oldOrders) {
    const orders = [];
    newOrders.forEach(order => {
      const newOrder = new Order(order);
      /**
       * Check with old structure and make sure rows
       * that were open stay open
       * 1. Find same orders
       * 2. If order is expanded, expand new equivalent
       * 3. Do same with order products
       */
      if (oldOrders.length > 0) {
        const matchingOrder = oldOrders.find(e => {
          return e.id === order.id;
        });
        if (matchingOrder) {
          if (matchingOrder.showProducts) {
            newOrder.showProducts = true;
            matchingOrder.products.forEach(product => {
              if (product.showProducts) {
                const newOrderProduct = newOrder.products.find(e => {
                  return e.id === product.id;
                });
                if (newOrderProduct) {
                  newOrderProduct.showProducts = true;
                }
              }
            });
          }
        }
      }
      orders.push(newOrder);
    });
    return orders;
  }

  getPreviewComments(workCenterId) {
    let comments = [];
    for (const product of this.products) {
      comments = [...comments, ...product.getPreviewComments(workCenterId)]
    }
    return comments;
  }

  getFilteredProducts() {
    return this.products.filter(product => {
      if (!product.pallet) {
        return true;
      }
      return product.pallet.owned;
    });
  }

  getOrderSuppliers(supplierId) {
    return this.suppliers.filter(e => {
      return e.supplier_id === supplierId;
    });
  }

  getSupplierDate(supplier) {
    return this.getSupplierDateText(this.getOrderSuppliers(supplier.id))
  }

  orderGetOtherSuppliers(suppliers) {
    const otherOrderSuppliers = this.suppliers.filter(e => {
      const matchingSupplier = suppliers.find(supplier => {
        return supplier.id == e.supplier_id;
      });
      return !matchingSupplier;
    });
    return otherOrderSuppliers;
  }

  getOtherSuppliersDate(suppliers) {
    return this.getSupplierDateText(this.orderGetOtherSuppliers(suppliers));
  }

  getPossibleStartDate(workCenters){
    const date = this.getSupplierDateText(this.suppliers, false);
    const possibleDate = new Date(date);
    if(this.suppliers.length == 0){
      return Helper.getShortDate(new Date());
    }
    if(possibleDate == "Invalid Date"){
      return date;
    }
    const operations = this.getWorkCentersOperations(workCenters);
    const completedOperations = Operation.getCompletedOperations(operations);
    if(operations.length == 0)
    {
      return Helper.getShortDate(new Date());
    }
    if(operations.length > completedOperations.length){
      return "???"
    }
    possibleDate.setDate(possibleDate.getDate() - 1)
    const weekends = [0,6];
    const weekday = possibleDate.getDay();
    if(weekends.includes(weekday)){
      //set to monday
      if(weekday == 6){
        possibleDate.setDate(possibleDate.getDate() + 2)
      }
      if(weekday == 0){
        possibleDate.setDate(possibleDate.getDate() + 1)
      }
    }
    return Helper.getFullDate(possibleDate);
  }

  getPossibleStartDateStyle(workCenters){
    let style = {
      'completion-date-cell': true
    }
    const date = this.getPossibleStartDate(workCenters);
    if(new Date(date) == "Invalid Date"){
      style['prepared-date-unknown'] = true
    } else {
      style['prepared-date-known'] = true
    }
    return style;
  }

  getSupplierDateText(orderSuppliers, shortDate = true) {
    //if no order suppliers
    if (orderSuppliers.length == 0) {
      return "-";
    }
    const notConfirmed = orderSuppliers.find(supplier => {
      return supplier.confirmed_delivery_date == null;
    });
    //if date unknown, show it
    if (notConfirmed) {
      return "???";
    }
    //return latest delivery_date
    orderSuppliers.sort((a, b) => {
      //gets dates of expected soonest products
      const dateA = new Date(a.confirmed_delivery_date);
      const dateB = new Date(b.confirmed_delivery_date);
      //get newest first
      return dateB.getTime() - dateA.getTime();
    })
    const date = new Date(orderSuppliers[0].confirmed_delivery_date);
    if(shortDate){
      return Helper.getShortDate(date);      
    } else {
      return Helper.getFullDate(date);
    }
  }

  getWeekText() {
    if (!this.week) {
      return "";
    }
    const week = `${this.week}`;
    return `W${week.substr(week.length - 2)}`;
  }

  async addSuppliers(suppliers) {
    const client = new HttpClient();
    const response = await client.instance.post(`orders/${this.id}/suppliers`, {
      order_suppliers: suppliers
    });
    return response.data;
  }

  getManagerName() {
    const managerEmail = this.manager_email;
    if (!managerEmail) {
      return "";
    }
    const emailParts = managerEmail.split("@");
    const emailName = emailParts[0];
    const nameParts = emailName.split('.');
    const name = Helper.capitalizeFirstLetter(nameParts[0]);
    const lastName = nameParts.length >= 2 ? nameParts[1].charAt(0).toUpperCase() : "";
    return `${name}${lastName}`;
  }

  getPaintStyle(){
    return {
      'paint-cell': true,
      'two-colored-paint': this.paint_type > 1 ? true : false,
      'number-cell': true
    }
  }

  getArea(){
    let area = 0;
    this.products.forEach(product => {
      area += product.area;
    });
    return parseFloat(`${area}`).toFixed(2);
  }
}
